/*
  BF-FIX-1: suggest-not-force region banner (see snippets/bf-region-banner.liquid and build/FIXES.md, Fix 1).

  Rules (reports/08-localisation.md, 7.3 and 7.4):
  - never switch country or language without a click;
  - never show to bots or automated browsers;
  - any explicit choice (any localization selector, either banner button) is stored in
    localStorage.bf_locale_choice = {"country","language","at"} and ends the suggestions;
  - exception: if the detected country differs from both the stored and the current country, and from the
    country Shopify detected when the choice was made (the visitor has travelled), suggest once more, then
    store the answer. A choice stored without a detected country (a manual pick before the first suggestion
    call returned, or the old theme's flag) is completed silently with today's detected country, so a visitor
    who has already chosen is never asked again at home;
  - Close (X) hides the banner for this tab only and is not a choice;
  - stored choices older than 12 months are ignored;
  - if storage throws (private mode), the banner shows at most once per page view and the page works.
  The country signal is Shopify's own /browsing_context_suggestions.json (first party).
*/
(function () {
  'use strict';

  var CHOICE_KEY = 'bf_locale_choice';
  var TRAVEL_KEY = 'bf_locale_travel_prompted';
  var CLOSED_KEY = 'bf_region_banner_closed';
  var LEGACY_MANUAL_KEY = 'shopify_manual_country_selected';
  var YEAR_MS = 365 * 24 * 60 * 60 * 1000;
  var BOT_RE = /bot|crawl|spider|slurp|googlebot|bingbot|gptbot|oai-searchbot|claudebot|perplexity|facebookexternalhit|lighthouse|headless/i;

  var root = document.getElementById('bf-region-banner');
  if (!root) return;

  var cfg;
  try {
    cfg = JSON.parse(root.querySelector('[data-bf-region-config]').textContent);
  } catch (e) {
    return;
  }

  function storageGet(area, key) {
    try { return window[area].getItem(key); } catch (e) { return null; }
  }
  function storageSet(area, key, value) {
    try { window[area].setItem(key, value); return true; } catch (e) { return false; }
  }

  function readChoice() {
    var raw = storageGet('localStorage', CHOICE_KEY);
    if (raw) {
      try {
        var c = JSON.parse(raw);
        if (c && c.at && Date.now() - Date.parse(c.at) < YEAR_MS) return c;
      } catch (e) { /* ignore a malformed value */ }
      return null;
    }
    /* A manual pick recorded by the old theme script counts as an explicit choice of the current country. */
    if (storageGet('localStorage', LEGACY_MANUAL_KEY) === '1') {
      return { country: cfg.current.country, language: cfg.current.language, at: null, legacy: true };
    }
    return null;
  }

  var lastDetected = null;

  function recordChoice(country, language) {
    storageSet('localStorage', CHOICE_KEY, JSON.stringify({
      country: country || cfg.current.country,
      language: language || cfg.current.language,
      detected: lastDetected,
      at: new Date().toISOString()
    }));
  }

  /* Persistence: every localization form on the page (header drawer, menu drawer, footer, banner). */
  function isLocalizationForm(form) {
    if (!form || !form.querySelector) return false;
    var type = form.querySelector('input[name="form_type"]');
    return (type && type.value === 'localization') || /\/localization(\?|$)/.test(form.getAttribute('action') || '');
  }
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('button[name="country_code"], button[name="locale_code"], button[name="language_code"]') : null;
    if (!button || !button.value || !isLocalizationForm(button.form)) return;
    if (button.name === 'country_code') recordChoice(button.value, null);
    else recordChoice(null, button.value);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isLocalizationForm(form)) return;
    var country = form.querySelector('input[name="country_code"]');
    var language = form.querySelector('input[name="language_code"], input[name="locale_code"]');
    if ((country && country.value) || (language && language.value)) {
      recordChoice(country && country.value, language && language.value);
    }
  }, true);

  /* Guards */
  var ua = navigator.userAgent || '';
  if (navigator.webdriver === true || BOT_RE.test(ua)) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (storageGet('sessionStorage', CLOSED_KEY) === '1') return;

  var choice = readChoice();
  var current = cfg.current.country;

  function fill(template, countryIso) {
    var c = cfg.countries[countryIso] || {};
    var currency = (c.currency || '') + (c.symbol && c.symbol !== c.currency ? ' ' + c.symbol : '');
    return String(template).split('__COUNTRY__').join(c.name || countryIso).split('__CURRENCY__').join(currency.trim());
  }

  function hide() {
    root.hidden = true;
  }

  function show(suggested, isTravel) {
    var text = root.querySelector('[data-bf-region-text]');
    var switchButton = root.querySelector('[data-bf-region-switch]');
    var stayButton = root.querySelector('[data-bf-region-stay]');
    var closeButton = root.querySelector('[data-bf-region-close]');

    text.textContent = fill(isTravel ? cfg.strings.travel : cfg.strings.suggest, suggested);
    switchButton.textContent = fill(cfg.strings['switch'], suggested);
    switchButton.value = suggested;
    stayButton.textContent = fill(cfg.strings.stay, current);

    /* The switch button is a submit button inside Shopify's localization form, so the capture listener
       above stores the choice before the form posts. */
    stayButton.addEventListener('click', function () {
      recordChoice(current, null);
      hide();
    });
    closeButton.addEventListener('click', function () {
      storageSet('sessionStorage', CLOSED_KEY, '1');
      hide();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        storageSet('sessionStorage', CLOSED_KEY, '1');
        hide();
      }
    });

    if (isTravel) storageSet('localStorage', TRAVEL_KEY, suggested);
    root.hidden = false;
    root.setAttribute('data-bf-region-shown', suggested);
    document.dispatchEvent(new CustomEvent('bf:region-banner-shown', { detail: { suggested: suggested, current: current, travel: !!isTravel } }));
  }

  function decide(data) {
    var part = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country;
    var detected = part && part.handle ? String(part.handle).toUpperCase() : null;
    var confidence = part && typeof part.confidence === 'number' ? part.confidence : 0;
    if (!detected && data && data.detected_values && data.detected_values.country) {
      detected = String(data.detected_values.country.handle || '').toUpperCase();
      confidence = 1;
    }
    if (!detected) return;
    lastDetected = detected;

    if (choice && !choice.detected) {
      /* Complete an older choice with where the visitor is now; never prompt on this basis. */
      choice.detected = detected;
      if (!choice.legacy) storageSet('localStorage', CHOICE_KEY, JSON.stringify(choice));
      else recordChoice(choice.country, choice.language);
      return;
    }

    if (detected === current) return;
    if (!cfg.countries[detected]) return;
    if (confidence < cfg.minConfidence) return;

    if (choice) {
      var travelled = detected !== String(choice.detected).toUpperCase() && detected !== String(choice.country || '').toUpperCase() && detected !== current;
      if (!travelled) return;
      if (storageGet('localStorage', TRAVEL_KEY) === detected) return;
      show(detected, true);
      return;
    }
    show(detected, false);
  }

  var base = String(cfg.root || '/').replace(/\/?$/, '/');
  var url = base + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true';

  fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then(function (response) { return response.ok ? response.json() : null; })
    .then(decide)
    .catch(function () { /* no suggestion; the page works as normal */ });
})();
